import { Chip, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function QuestClearedChip({ isCleared }) {
  const { t, i18n } = useTranslation(["common"]);
  return isCleared ? (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Chip
        label={t("common:QuestClearedChip.cleared")} //"クリア済み"
        sx={(theme) => ({
          ...theme.components.questCard.chip.cleared,
        })}
      />
    </Box>
  ) : (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Chip
        label={t("common:QuestClearedChip.uncleared")} //"未クリア"
        sx={(theme) => ({
          ...theme.components.questCard.chip.uncleared,
        })}
      />
    </Box>
  );
}
